'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_MeasuringUnit(id) {
  this.za = null;
  this.za = id;
}
export { $c_Lmealorama_MeasuringUnit as $c_Lmealorama_MeasuringUnit };
$p = $c_Lmealorama_MeasuringUnit.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_MeasuringUnit;
/** @constructor */
function $h_Lmealorama_MeasuringUnit() {
}
export { $h_Lmealorama_MeasuringUnit as $h_Lmealorama_MeasuringUnit };
$h_Lmealorama_MeasuringUnit.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-4836884), true);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lmealorama_MeasuringUnit) && (this.za === x$0.za)));
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 1;
});
$p.r = (function() {
  return "MeasuringUnit";
});
$p.g = (function(n) {
  if ((n === 0)) {
    return this.za;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
});
function $isArrayOf_Lmealorama_MeasuringUnit(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jI)));
}
export { $isArrayOf_Lmealorama_MeasuringUnit as $isArrayOf_Lmealorama_MeasuringUnit };
var $d_Lmealorama_MeasuringUnit = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_MeasuringUnit, "mealorama.MeasuringUnit", ({
  jI: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_MeasuringUnit as $d_Lmealorama_MeasuringUnit };
//# sourceMappingURL=mealorama.-Measuring-Unit.js.map
